export const genderList = [
    'male', 'female', 'other'
];

export const educationList = [
    'early', 'primary', 'lower', 'upper', 'post-secondary', 'short-cycle', 'bachelor',
    'master', 'doctoral'
];

export const employmentList = [
    'full-time', 'part-time', 'self-employed', 'freelance', 'contract', 'seasonal',
    'internship', 'apprenticeship', 'student', 'volunteer', 'retired', 'unemployed'
];

export const skillList = [
    'py', 'java', 'js', 'c', 'ruby', 'swift', 'go', 'php', 'html_css', 'java_kotlin_android',
    'react', 'angular', 'vue', 'node', 'statistical_analysis', 'sql', 'r', 'tableau', 'power_bi',
    'matlab', 'sas', 'db_management', 'ml_algorithms', 'deep_learning', 'nlp', 'opencv',
    'tensorflow', 'pytorch', 'openai_gym', 'rllib', 'aws', 'azure', 'gcp', 'ibm_cloud',
    'cloud_infrastructure', 'docker', 'kubernetes', 'serverless', 'lambda', 'azure_functions',
    'network_security', 'network_protocols', 'firewall', 'vpn', 'penetration_testing',
    'incident_response', 'digital_forensics', 'project_planning', 'risk_management',
    'project_documentation', 'seo', 'sem', 'google_ads', 'social_media_marketing', 'ab_testing',
    'ux_optimisation', 'adobe_cs', 'illustrations', 'graphic_design', 'prototype', 'adobe_xd',
    'sketch', 'figma', 'invision', 'data_analysis', 'google_analytics', 'risk_analysis',
    'corp_finance', 'writing', 'translation', 'teaching_languages', 'verbal_communication',
    'written_communication', 'emotional_intelligence', 'interpersonal', 'collaboration',
    'conflict_resolution', 'presentation', 'negotiation', 'teamwork', 'communication',
    'problem_solving', 'adaptability', 'decision_making', 'networking', 'analytical',
    'evaluation', 'creativity', 'problem_analysis', 'research', 'time_management', 'organisation',
    'cert_scrum_product_owner', 'agile_certified_practitioner', 'ms_access', 'ms_excel',
    'ms_office', 'ms_project', 'ms_word', 'computer', 'photoshop', '3d_modeling', 'video_editing',
    'data_visualisation', 'bpm', 'sap', 'logistics', 'event_management', 'report_writing',
    'quality_assurance', 'finance', 'accounting', 'robotics', 'automation', 'hardware',
    'wordpress', 'ecommerce', 'cms', 'active_directory', 'blockchain', 'cloud', 'sql_server',
    'oop', 'scripting', 'statistics', 'data_management', 'ccna', 'data_warehouse',
    'technical_support', 'mathematics', 'iot', 'ai', 'spss', 'risk_assessment',
    'performance_tracking', 'data_reporting', 'crisis_management', 'cooking', 'customer_care',
    'food_preparation', 'quality_control', 'health_care', 'patient_care', 'medical_administration',
    'contract_law', 'court_proceedings', 'civil_proceedings', 'legal_writing', 'legal_research',
    'civil_law', 'criminal_law', 'legal_analysis', 'advising_clients', 'legal_due_diligence',
    'legal_compliance', 'adr', 'legal_software_and_technology',
    'preparation_and_management_of_documents', 'crm', 'salesforce', 'data_entry',
    'technical_troubleshooting', 'knowledge_base_management', 'inventory', 'material_handling',
    'workflow_optimisation', 'refund_processing', 'cargo_management', 'customs_compliance',
    'guidance_and_planning', 'resource_allocation', 'scm', 'hrm', 'counselling', 'hr',
    'web_development', 'sdlc', 'version_control', 'agile_scrum', 'network_management',
    'sys_admin', 'it_troubleshooting', 'cyber_security', 'cloud_computing', 'devops_tools',
    'scripting_languages', 'big_data_technologies', 'data_visualisation_tools',
    'machine_learning_and_ai', 'data_mining', 'mobile_app_development', 'ui', 'ux',
    'web_frameworks', 'automated_testing'
];

export const questionTypeList = [
    {
        type: 'singleChoice',
        icon: 'mdi:radio-button-checked'
    },
    {
        type: 'multipleChoice',
        icon: 'mingcute:checkbox-line'
    }
];